import defineMessages from "../../../common/helpers/defineMessages";

const messages = defineMessages({
    title: {
        id: "help.title",
    },
    rhytNameTitle: {
        id: "article.rhytname.hello.title",
    },
    metaTitle: {
        id: "article.meta.title",
    },
    listingTitle: {
        id: "articles.listing.title",
    },
    filterTitle: {
        id: "article.filters.title",
    },
    distanceTeaching: {
        id: "article.covid.title",
    },
    experience: {
        id: "plan.experience"
    },
    moderation: {
        id: "help.moderation.title"
    },
});

export default messages;
